import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Theme, Grid } from '@material-ui/core'
import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'
import StepConnector from '@material-ui/core/StepConnector'
import StepLabel from '@material-ui/core/StepLabel'
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight'
import { Link } from '@src/components/Link'
import clsx from 'clsx'

const useStyles = makeStyles((theme: Theme) => {
  return {
    root: {
      color: theme.palette.grey[300],
      border: 'solid',
      borderColor: theme.palette.grey[300],
      fill: theme.palette.common.white,
      borderWidth: 2,
      borderRadius: 24,
      width: theme.typography.pxToRem(27),
      height: theme.typography.pxToRem(27),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 700,
      fontSize: theme.typography.pxToRem(17),
    },
    active: {
      borderColor: theme.palette.primary.main,
      color: theme.palette.primary.main,
    },
    completed: {
      backgroundColor: theme.palette.primary.main,
      border: 'none',
      color: theme.palette.common.white,
    },
    completedLabel: {
      color: theme.palette.grey[100],
      fontWeight: theme.typography.fontWeightRegular,
    },
    label: {
      fontSize: theme.typography.pxToRem(22),
      fontWeight: theme.typography.fontWeightRegular,
    },
    activeGrid: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    disabledLink: {
      color: theme.palette.grey[500],
      pointerEvents: 'none',
    },
    notClickable: {
      pointerEvents: 'none',
    },
    activeLink: {
      color: theme.palette.primary.main,
      alignSelf: 'flex-end',
    },
    stepperContainer: {
      backgroundColor: 'transparent',
      padding: theme.spacing(3, 0),
      marginTop: theme.spacing(17),
    },
    resetConnector: {
      minHeight: 50,
    },
    resetVertical: {
      padding: 0,
    },
    activelink: {
      fontWeight: theme.typography.fontWeightBold,
      cursor: 'pointer',
    },
    activelinkZH: {
      fontWeight: theme.typography.fontWeightBold,
      cursor: 'pointer',
      fontSize: theme.typography.pxToRem(20.6),
    },
    cursor: {
      cursor: 'pointer',
    },
  }
})

export interface SidebarItem {
  url?: string
  label: any
  activeLink?: boolean
  linkDisable?: boolean
  linkNotClickable?: boolean
}

export interface SidebarProps {
  items: SidebarItem[]
  activeStep: number
  langZh?: boolean
  isNotNavigateable?: boolean
  displayErrorPopUpOnReview?: any
}

const Sidebar: React.FC<SidebarProps> = ({
  items,
  activeStep,
  langZh,
  isNotNavigateable,
  displayErrorPopUpOnReview,
}) => {
  const classes = useStyles()
  const CustomStepIcon = (props) => {
    const { active, completed } = props
    const icons = {}
    items.forEach((_, index) => {
      icons[index + 1] = (index + 1).toString()
    })
    return (
      <div
        className={clsx(classes.root, {
          [classes.active]: active,
          [classes.completed]: completed,
        })}
      >
        {icons[String(props.icon)]}
      </div>
    )
  }

  const displayErrorPopUp = (e) => {
    if (isNotNavigateable) {
      displayErrorPopUpOnReview()
      e.preventDefault()
      return true
    } else {
      return false
    }
  }
  return (
    <Stepper
      activeStep={activeStep}
      orientation="vertical"
      connector={
        <StepConnector
          classes={{
            lineVertical: classes.resetConnector,
            vertical: classes.resetVertical,
          }}
        />
      }
      classes={{ root: classes.stepperContainer }}
      id="stepper-container"
      data-testid="stepper-container"
    >
      {items.map((item, index) => (
        <Step key={index}>
          <StepLabel
            classes={{
              completed: classes.completedLabel,
              label: classes.label,
            }}
            StepIconComponent={CustomStepIcon}
          >
            <Link href={item.url!} passHref>
              <Grid
                container
                onClick={
                  isNotNavigateable !== undefined && isNotNavigateable !== false
                    ? (e) => {
                        displayErrorPopUp(e)
                      }
                    : undefined
                }
                className={clsx(
                  item.linkDisable
                    ? classes.disabledLink
                    : item.linkNotClickable
                      ? classes.notClickable
                      : item.activeLink
                        ? langZh
                          ? classes.activelinkZH
                          : classes.activelink
                        : classes.cursor
                )}
              >
                <Grid item sm={11}>
                  {item.label}
                </Grid>

                <Grid item sm={1} className={classes.activeGrid}>
                  {item.activeLink && (
                    <KeyboardArrowRight className={classes.activeLink} />
                  )}
                </Grid>
              </Grid>
            </Link>
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  )
}

export default Sidebar
